import ApiService from '../apiservice'

export default class RelatorioAtividadeService extends ApiService {
  constructor() {
    super('/relatorioAtividade')
  }

  relatorioAtividade(filtro) {
    let params = `/relatorio?empresa=${filtro.empresa}&usuario=${filtro.usuario}`
    //Data Limite
    params = `${params}&dtLimiteInicial=${filtro.dtLimiteInicial}&dtLimiteFinal=${filtro.dtLimiteFinal}`;
    //Data de Cadastro
    params = `${params}&dtCriacaoInicial=${filtro.dtCriacaoInicial}&dtCriacaoFinal=${filtro.dtCriacaoFinal}`;
    //Data Concluído
    params = `${params}&dtConcluidoInicial=${filtro.dtConcluidoInicial}&dtConcluidoFinal=${filtro.dtConcluidoFinal}`;
    // Data de Alteração
    params = `${params}&dtAlteracaoInicial=${filtro.dtAlteracaoInicial}&dtAlteracaoFinal=${filtro.dtAlteracaoFinal}`;
    //Prazo Fatal
    params = `${params}&dtFatalInicial=${filtro.dtFatalInicial}&dtFatalFinal=${filtro.dtFatalFinal}`;
    //Responsável
    params = `${params}&responsavel=${filtro.responsavel}`;
    //Interessado
    params = `${params}&interessado=${filtro.interessado}`;
    //Grupo de Trabalho
    params = `${params}&grupoTrabalho=${filtro.grupoTrabalho}`;
    //Status
    params = `${params}&status=${filtro.status}`;
    //Tipo de Atividade
    params = `${params}&tipoAtividade=${filtro.tipoAtividade}`;
    //Classificação
    params = `${params}&classificacao=${filtro.classificacao}`;
    //Ordenação
    params = `${params}&ordenacao=${filtro.ordenacao}`;
    return this.get(params);
  }

  exportarRelatorio(filtro) {
    return this.post('/exportar',filtro);
  }

  download(codigo) {
    return this.get2(`/download/${codigo}`);
  }

  consultarRelatorio(codigo) {
    return this.get(`/consultarRelatorio/${codigo}`);
  }

  consultarRelatorioGerado(usuario) {
    return this.get(`/relatorioGerado/${usuario}`);
  }

  excluirRelatorio(codigo) {
    return this.delete(`/${codigo}`);
  }
}